import { useMemo } from "react";
import { SearchAndFilterTypes, VISIBILITY_FILTER_OPTIONS } from "src/constants";
import { ButtonFilter, CommonFilterProps, FormFilter } from "../CommonFilters";

export const VisibilityFilter = (props: CommonFilterProps) => {
  const options = useMemo(() => {
    return VISIBILITY_FILTER_OPTIONS.map((option) => ({
      label: option.label,
      id: option.key,
    }));
  }, []);

  return (
    <FormFilter label="Visibility">
      <ButtonFilter
        options={options}
        filterKey={SearchAndFilterTypes.Visibility}
        {...props}
      />
    </FormFilter>
  );
};
